import { ICON_MAP } from "./IconData";
import "./index.scss";

const Icon = ({
    iconName,
    width = 24,
    height = 24,
    className = "",
    onClick = () => { },
}) => {
    const IconComponent = ICON_MAP[iconName];

    if (!IconComponent) {
        console.warn(`Icon: unknown iconName "${iconName}"`);
        return null;
    }

    return (
        <IconComponent
            className={`icon ${onClick ? "icon-clickable" : ""} ${className}`}
            width={width}
            height={height}
            style={{ width: `${width}px`, height: `${height}px` }}
            onClick={onClick}
        />
    );
};

export default Icon;
